// SnapshotSelector — versioned cap-table snapshots (F1.8). Presentation.
// P1: a simple create/select picker (P2 replaces with full versioning).

import { History } from 'lucide-react';
import { useStore } from '../../store/selectors';
import { EmptyState } from '../common/EmptyState';

export function SnapshotSelector({ entity }: { entity: string }) {
  const caps = useStore((s) => (entity ? s.capTablesByEntity[entity] ?? [] : []));
  const activeId = useStore((s) => s.activeCapTableId);
  const selectSnapshot = useStore((s) => s.selectSnapshot);
  const commitSnapshot = useStore((s) => s.commitSnapshot);
  const draft = useStore((s) => s.draftCapTable);

  return (
    <div className="card">
      <div className="card-title">Snapshots</div>
      {caps.length === 0 ? (
        <EmptyState
          icon={<History size={28} strokeWidth={1.5} />}
          message="No committed snapshots yet."
          hint="Snapshots freeze a cap table at a point in time so a valuation always points at a stable version. Commit your draft to create the first one."
        />
      ) : (
        <ul className="stack-1">
          {caps.map((c) => (
            <li key={c.id}>
              <button
                type="button"
                className={`sidebar-item ${c.id === activeId ? 'active' : ''}`}
                onClick={() => selectSnapshot(entity, c.id)}
              >
                v{c.version} — {c.asOfDate}
              </button>
            </li>
          ))}
        </ul>
      )}
      <button
        type="button"
        className="btn btn-secondary mt-3"
        style={{ width: '100%' }}
        disabled={!draft}
        onClick={() => draft && commitSnapshot(entity, draft)}
      >
        Commit Snapshot
      </button>
    </div>
  );
}
